import { HexColorInput } from "./HexColorInput";
import { useCommonLabels } from "../../i18n/hooks";

export default function CoverTextColorField() {
  const c = useCommonLabels();
  return (
    <HexColorInput
      source="TextColor"
      label={c.textColor}
      defaultValue="#FFFFFF"
      helperText="Цвет заголовка и описания поверх обложки"
    />
  );
}
